/* OPJERSEY Matchday theme. Vanilla JS, no dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Helpers ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  function lockScroll(on) { document.body.classList.toggle('is-locked', on); }

  // Simple modal controller: open/close, Esc, focus return, focus trap.
  function modal(el, { onOpen, onClose } = {}) {
    let lastFocus = null;
    const api = {
      el,
      isOpen: () => !el.hidden,
      open(trigger) {
        lastFocus = trigger || document.activeElement;
        el.hidden = false;
        requestAnimationFrame(() => el.classList.add('is-open'));
        lockScroll(true);
        onOpen && onOpen();
      },
      close() {
        if (el.hidden) return;
        el.classList.remove('is-open');
        el.hidden = true;
        lockScroll(false);
        onClose && onClose();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    };
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { api.close(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', el)
        .filter((n) => n.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return api;
  }

  /* ---------- Header: scrolled state via sentinel (no scroll listener) ---------- */
  function initHeader() {
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80px;pointer-events:none;';
    document.body.prepend(sentinel);
    new IntersectionObserver(([entry]) => {
      document.documentElement.classList.toggle('is-scrolled', !entry.isIntersecting);
    }).observe(sentinel);
  }

  /* ---------- Mega menu ---------- */
  function initMega() {
    $$('.nav__item--mega').forEach((item) => {
      const btn = $('[data-mega-toggle]', item);
      let closeTimer;
      const set = (open) => {
        clearTimeout(closeTimer);
        $$('.nav__item--mega.is-open').forEach((o) => { if (o !== item) { o.classList.remove('is-open'); $('[data-mega-toggle]', o).setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      };
      btn.addEventListener('click', () => set(!item.classList.contains('is-open')));
      item.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) set(true); });
      item.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => set(false), 160); });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) set(false); });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const el = $('[data-mobile-menu]');
    if (!el) return;
    const openBtn = $('[data-menu-open]');
    const m = modal(el, {
      onOpen: () => { openBtn && openBtn.setAttribute('aria-expanded', 'true'); const c = $('[data-menu-close]', el); c && c.focus(); },
      onClose: () => openBtn && openBtn.setAttribute('aria-expanded', 'false')
    });
    openBtn && openBtn.addEventListener('click', () => m.open(openBtn));
    $$('[data-menu-close]', el).forEach((b) => b.addEventListener('click', () => m.close()));
  }

  /* ---------- Search overlay + predictive search ---------- */
  function initSearch() {
    const el = $('[data-search-overlay]');
    if (!el) return;
    const input = $('[data-predictive-input]', el);
    const results = $('[data-predictive-results]', el);
    const m = modal(el, { onOpen: () => setTimeout(() => input.focus(), 30) });
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => m.open(b)));
    $$('[data-search-close]', el).forEach((b) => b.addEventListener('click', () => m.close()));
    el.addEventListener('click', (e) => { if (e.target === el) m.close(); });

    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        controller && controller.abort();
        controller = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
          const res = await fetch(url, { signal: controller.signal });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.psearch');
          results.innerHTML = content ? content.outerHTML : '';
        } catch (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        }
      }, 220);
    });
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      const msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2 || reduceMotion) return;
      let i = 0;
      setInterval(() => {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4500);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, obs) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 })
    : null;
  function initReveal(root = document) {
    $$('[data-reveal-group]', root).forEach((g) => {
      if (!revealObserver || reduceMotion) g.classList.add('is-in');
      else revealObserver.observe(g);
    });
  }

  /* ---------- Rail arrows ---------- */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach((rail) => {
      const section = rail.closest('section');
      const step = () => Math.max(rail.clientWidth * 0.8, 240);
      const prev = $('[data-rail-prev]', section);
      const next = $('[data-rail-next]', section);
      const behavior = reduceMotion ? 'auto' : 'smooth';
      prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior }));
      next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior }));
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = $('input', wrap);
    const min = (wrap.dataset.lineQty || wrap.closest('[data-cart-page]')) ? 0 : 1;
    const val = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const cart = {
    drawer: null,
    sectionId: 'cart-drawer',
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: [this.sectionId], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    render(sections) {
      const html = sections && sections[this.sectionId];
      if (!html || !this.drawer) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      if (!fresh) return;
      const panel = $('.drawer__panel', this.drawer.el);
      panel.innerHTML = $('.drawer__panel', fresh).innerHTML;
      this.setCount(parseInt(fresh.dataset.count, 10) || 0);
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = n;
        el.hidden = n === 0;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    },
    async add(variantId, quantity = 1, trigger) {
      // Drawer mode only. In page mode forms submit normally.
      const data = await this.request(T.routes.cartAdd + '.js', { items: [{ id: Number(variantId), quantity }] });
      this.render(data.sections);
      this.drawer && this.drawer.open(trigger);
      return data;
    },
    async change(line, quantity) {
      const row = this.drawer && $(`[data-line="${line}"]`, this.drawer.el);
      row && row.classList.add('is-busy');
      try {
        const data = await this.request(T.routes.cartChange + '.js', { line: Number(line), quantity });
        this.render(data.sections);
      } catch (err) {
        row && row.classList.remove('is-busy');
        toast(err.message);
      }
    },
    init() {
      const el = $('[data-cart-drawer]');
      if (el) {
        this.drawer = modal(el, { onOpen: () => { const p = $('.drawer__panel', el); p && p.focus(); } });
        $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
          if (window.location.pathname === T.routes.cart) return;
          e.preventDefault();
          this.drawer.open(a);
        }));
        el.addEventListener('click', (e) => {
          if (e.target.closest('[data-cart-close]')) { this.drawer.close(); return; }
          const rm = e.target.closest('[data-line-remove]');
          if (rm) this.change(rm.dataset.lineRemove, 0);
        });
        let qtyTimer;
        el.addEventListener('change', (e) => {
          const wrap = e.target.closest('[data-line-qty]');
          if (!wrap) return;
          clearTimeout(qtyTimer);
          qtyTimer = setTimeout(() => this.change(wrap.dataset.lineQty, Math.max(0, parseInt(e.target.value, 10) || 0)), 300);
        });
      }

      // Cart page: auto-submit quantity changes (Shopify handles updates[])
      const page = $('[data-cart-page]');
      if (page) {
        let t;
        page.addEventListener('change', (e) => {
          if (!e.target.matches('.qty__input')) return;
          clearTimeout(t);
          t = setTimeout(() => {
            const fd = new FormData(page);
            fd.append('update', '1');
            fetch(T.routes.cart + '/update', { method: 'POST', body: fd }).then(() => window.location.reload());
          }, 400);
        });
      }

      // Quick add from product cards
      document.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-quick-add]');
        if (!btn) return;
        e.preventDefault();
        if (!this.drawer) {
          // Page mode: post a regular form to /cart/add
          const f = document.createElement('form');
          f.method = 'post';
          f.action = T.routes.cartAdd;
          f.innerHTML = `<input type="hidden" name="id" value="${btn.dataset.quickAdd}"><input type="hidden" name="quantity" value="1">`;
          document.body.appendChild(f);
          f.submit();
          return;
        }
        btn.disabled = true;
        try { await this.add(btn.dataset.quickAdd, 1, btn); }
        catch (err) { toast(err.message); }
        finally { btn.disabled = false; }
      });
    }
  };

  /* ---------- Product form & variant picker ---------- */
  function initProduct(root = document) {
    $$('[data-product-section]', root).forEach((section) => {
      const form = $('[data-product-form]', section);
      if (!form) return;
      const jsonEl = $('[data-product-json]', section);
      const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      const idInput = $('[data-variant-id]', form);
      const addBtn = $('[data-add-button]', form);
      const addLabel = $('[data-add-label]', form);
      const errorEl = $('[data-form-error]', form);
      const pickers = $$('.picker', form);
      const currentOptions = () => pickers.map((p) => {
        const checked = $('input:checked', p);
        return checked ? checked.value : null;
      });

      const updateAvailability = (selected) => {
        // Mark option values that have no available variant given the other selections.
        pickers.forEach((p, idx) => {
          $$('input', p).forEach((input) => {
            const opts = selected.slice();
            opts[idx] = input.value;
            const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
            const label = input.nextElementSibling;
            label && label.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      };

      const onChange = async () => {
        const selected = currentOptions();
        pickers.forEach((p, i) => { const s = $('[data-option-value]', p); if (s) s.textContent = selected[i] || ''; });
        const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        updateAvailability(selected);
        errorEl.hidden = true;

        if (!variant) {
          addBtn.disabled = true;
          addLabel.textContent = T.strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        // Refresh price block from the server so money formatting matches the store exactly.
        try {
          const res = await fetch(`${section.dataset.productUrl}?variant=${variant.id}&section_id=${section.dataset.sectionId}`);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshPrice = doc.querySelector('[data-price-wrap]');
          const price = $('[data-price-wrap]', section);
          if (freshPrice && price) price.innerHTML = freshPrice.innerHTML;
        } catch (_) { /* price stays as-is */ }

        if (variant.featured_media) {
          const media = $(`[data-media-id="${variant.featured_media.id}"]`, section);
          const list = $('[data-media-list]', section);
          if (media && list) {
            if (list.scrollWidth > list.clientWidth + 4) list.scrollTo({ left: media.offsetLeft - list.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
            else if (window.matchMedia('(min-width: 990px)').matches && media !== list.firstElementChild) list.prepend(media);
          }
        }
      };

      form.addEventListener('change', (e) => { if (e.target.name && e.target.name.startsWith('option-')) onChange(); });
      if (pickers.length) updateAvailability(currentOptions());

      form.addEventListener('submit', async (e) => {
        if (!cart.drawer) return; // page mode: native submit
        e.preventDefault();
        if (addBtn.disabled) return;
        const qtyInput = $('input[name="quantity"]', form);
        addBtn.classList.add('is-loading');
        addLabel.textContent = T.strings.adding;
        errorEl.hidden = true;
        try {
          await cart.add(idInput.value, Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1), addBtn);
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } finally {
          addBtn.classList.remove('is-loading');
          addLabel.textContent = addBtn.disabled ? T.strings.soldOut : T.strings.addToCart;
        }
      });

      // Mobile gallery dots
      const list = $('[data-media-list]', section);
      const dots = $$('.pdp__dots span', section);
      if (list && dots.length && 'IntersectionObserver' in window) {
        const items = Array.from(list.children);
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              const i = items.indexOf(en.target);
              dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
            }
          });
        }, { root: list, threshold: 0.6 });
        items.forEach((it) => io.observe(it));
      }
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          el.setAttribute('data-reveal-group', '');
          initReveal(el.parentElement);
        }
      } catch (_) { /* leave empty */ }
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters(root = document) {
    $$('[data-filter-form]', root).forEach((form) => {
      const panel = $('[data-filters]', form);
      const openBtn = $('[data-filters-open]', form);
      if (panel && openBtn) {
        const m = modal(panel, {
          onOpen: () => openBtn.setAttribute('aria-expanded', 'true'),
          onClose: () => openBtn.setAttribute('aria-expanded', 'false')
        });
        openBtn.addEventListener('click', () => m.open(openBtn));
        $$('[data-filters-close]', panel).forEach((b) => b.addEventListener('click', () => m.close()));
        panel.addEventListener('click', (e) => { if (e.target === panel) m.close(); });
      }
      $$('[data-autosubmit]', form).forEach((s) => s.addEventListener('change', () => submitFilters(form)));
      form.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(form); });
    });
  }
  function submitFilters(form) {
    // Drop empty fields so URLs stay clean (Shopify ignores them anyway).
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    window.location.href = `${form.action}?${params.toString()}`;
  }

  /* ---------- Localization selector ---------- */
  function initLocalization() {
    $$('[data-localization-form] select').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  }

  /* ---------- Account bits ---------- */
  function initAccount() {
    $$('[data-recover-toggle]').forEach((a) => a.addEventListener('click', () => {
      const p = $('[data-recover-panel]');
      if (p) { p.classList.add('is-open'); const i = $('input[type="email"]', p); i && i.focus(); }
    }));
    if ($('[data-recover-panel] .form-msg')) $('[data-recover-panel]').classList.add('is-open');
    $$('form[data-confirm]').forEach((f) => f.addEventListener('submit', (e) => { if (!window.confirm(f.dataset.confirm)) e.preventDefault(); }));
    $$('select[data-default]').forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* ---------- Locker-room physics: hangers swing like pendulums ----------
     One rAF loop runs only while a hanger (or the 3D shirt) is on screen. It reads
     scroll speed each frame (no scroll listener) and turns scroll acceleration into a
     swing impulse. Each hanger is a damped spring on its rotate angle. */
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const Physics = (() => {
    const visible = new Set();
    const listeners = new Set();
    let raf = 0, lastT = 0, lastY = window.scrollY, lastV = 0, n = 0;
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const it = e.target._swing;
        if (e.isIntersecting) {
          visible.add(it);
          if (!it.arrived) {
            it.arrived = true;
            setTimeout(() => kick(it, it.dir * (0.9 + Math.random() * 0.5)), it.delay);
          }
        } else visible.delete(it);
      });
      start();
    }, { rootMargin: '80px 0px' }) : null;

    function frame(t) {
      const dt = Math.min(0.033, lastT ? (t - lastT) / 1000 : 0.016);
      lastT = t;
      const y = window.scrollY;
      const v = (y - lastY) / dt;
      lastY = y;
      const drive = clamp((v - lastV) * 0.00005, -0.5, 0.5);
      lastV = v;
      listeners.forEach((fn) => fn(v, drive));
      visible.forEach((it) => {
        it.v += (-it.k * it.a - it.c * it.v) * dt + drive * it.dir;
        it.a = clamp(it.a + it.v * dt, -0.5, 0.5);
        if (Math.abs(it.a - it.drawn) > 0.0002) {
          it.drawn = it.a;
          it.el.style.rotate = it.a.toFixed(4) + 'rad';
        }
      });
      raf = (visible.size || listeners.size) ? requestAnimationFrame(frame) : 0;
    }
    function start() {
      if (!raf && (visible.size || listeners.size)) { lastT = 0; lastY = window.scrollY; lastV = 0; raf = requestAnimationFrame(frame); }
    }
    function kick(it, dv) { it.v += dv; start(); }
    function add(el) {
      if (el._swing || reduceMotion || !io) return;
      const d = parseFloat(el.style.getPropertyValue('--d')) || 0;
      const it = el._swing = {
        el, a: 0, v: 0, drawn: 0,
        k: 22 + Math.random() * 14, c: 2.2 + Math.random() * 0.8,
        dir: (n++ % 2 ? -1 : 1) * (0.7 + Math.random() * 0.6),
        delay: d * 140 + 520 + (n % 5) * 90, arrived: false
      };
      el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') kick(it, clamp((e.movementX || 2) * 0.06, -0.9, 0.9)); });
      el.addEventListener('pointerdown', () => kick(it, (Math.random() > 0.5 ? 1 : -1) * 1.1));
      io.observe(el);
    }
    function listen(fn) { listeners.add(fn); start(); return () => listeners.delete(fn); }
    function remove(fn) { listeners.delete(fn); }
    return { add, listen, remove };
  })();

  function initSwing(root = document) { $$('[data-swing]', root).forEach((el) => Physics.add(el)); }

  /* ---------- 3D OPJERSEY shirt (img2threejs build, lazy, WebGL only) ---------- */
  function initJersey3D(root = document) {
    $$('[data-jersey3d]', root).forEach((el) => {
      if (el.dataset.mounted) return;
      el.dataset.mounted = '1';
      const conn = navigator.connection;
      if (conn && conn.saveData) return;
      const probe = document.createElement('canvas');
      if (!(probe.getContext('webgl2') || probe.getContext('webgl'))) return;
      const go = async () => {
        try {
          const [THREE, mod] = await Promise.all([import(el.dataset.three), import(el.dataset.module)]);
          const mount = mod[el.dataset.export || 'mountJersey'];
          const rail = el.closest('[data-kitrail]');
          const api = mount(el, THREE, {
            reducedMotion: reduceMotion,
            onReady: () => { el.classList.add('is-live'); if (rail) rail.classList.add('is-live'); }
          });
          if (api && api.impulse) {
            const off = Physics.listen((v, drive) => { if (drive) api.impulse(drive * 1.6, 0); });
            el._jersey = { api, off };
          }
          el.addEventListener('pointerdown', () => { const r = el.closest('[data-kitrail]'); (r || el).classList.add('was-dragged'); }, { once: true });
        } catch (err) {
          // Fallback card stays visible.
        }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '200px' });
        io.observe(el);
      } else go();
    });
  }

  /* ---------- Goal net (newsletter): a mesh that dents where you touch it ---------- */
  function initNet(root = document) {
    $$('[data-net]', root).forEach((canvas) => {
      if (canvas._net) return;
      canvas._net = true;
      const section = canvas.parentElement;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      let W = 0, H = 0, dpr = 1, gap = 32, cols = 0, rows = 0, pts = [], raf = 0, visible = false, energy = 0;
      const pointer = { x: -1e4, y: -1e4, on: false };

      const color = () => getComputedStyle(document.documentElement).getPropertyValue('--line-strong').trim() || 'rgba(245,246,247,.3)';
      function build() {
        dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        W = section.clientWidth; H = section.clientHeight;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        gap = W < 750 ? 24 : 32;
        cols = Math.ceil(W / gap) + 1; rows = Math.ceil(H / gap) + 1;
        pts = [];
        for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
          // slight sag toward the bottom, like a net hanging off a crossbar
          const x0 = i * gap, y0 = j * gap + Math.sin((i / (cols - 1)) * Math.PI) * j * 0.6;
          pts.push({ x0, y0, x: x0, y: y0, vx: 0, vy: 0, pin: j === 0 || i === 0 || i === cols - 1 });
        }
        draw();
      }
      function draw() {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H);
        ctx.strokeStyle = color();
        ctx.globalAlpha = 0.42;
        ctx.lineWidth = 1;
        ctx.beginPath();
        // diagonal links only: the diamond mesh of a goal net
        for (let j = 0; j + 1 < rows; j++) for (let i = 0; i < cols; i++) {
          const p = pts[j * cols + i];
          if (i + 1 < cols) { const q = pts[(j + 1) * cols + i + 1]; ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); }
          if (i > 0) { const q = pts[(j + 1) * cols + i - 1]; ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); }
        }
        ctx.stroke();
      }
      function step() {
        energy = 0;
        const R = W < 750 ? 70 : 110;
        for (let k = 0; k < pts.length; k++) {
          const p = pts[k];
          if (p.pin) continue;
          const i = k % cols, j = (k / cols) | 0;
          const l = pts[k - 1], r = pts[k + 1], u = pts[k - cols], d = j + 1 < rows ? pts[k + cols] : p;
          // neighbour coupling makes dents ripple outwards; spring pulls back to rest
          const ax = ((l.x - l.x0) + (r.x - r.x0) + (u.x - u.x0) + (d.x - d.x0)) / 4 - (p.x - p.x0);
          const ay = ((l.y - l.y0) + (r.y - r.y0) + (u.y - u.y0) + (d.y - d.y0)) / 4 - (p.y - p.y0);
          p.vx += ax * 0.35 - (p.x - p.x0) * 0.03;
          p.vy += ay * 0.35 - (p.y - p.y0) * 0.03;
          if (pointer.on) {
            const dx = p.x - pointer.x, dy = p.y - pointer.y, dist = Math.hypot(dx, dy);
            if (dist < R && dist > 0.1) { const f = (1 - dist / R) * 1.4; p.vx += (dx / dist) * f; p.vy += (dy / dist) * f; }
          }
          p.vx *= 0.9; p.vy *= 0.9;
          p.x += p.vx; p.y += p.vy;
          energy += Math.abs(p.vx) + Math.abs(p.vy);
        }
      }
      function loop() {
        step(); draw();
        raf = (visible && (pointer.on || energy > 0.4)) ? requestAnimationFrame(loop) : 0;
      }
      const wake = () => { if (!raf && visible && !reduceMotion) raf = requestAnimationFrame(loop); };
      const pos = (e) => { const r = section.getBoundingClientRect(); pointer.x = e.clientX - r.left; pointer.y = e.clientY - r.top; };

      build();
      if (reduceMotion) return;
      new ResizeObserver(() => build()).observe(section);
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) wake(); }).observe(section);
      section.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse') return; pos(e); pointer.on = true; wake(); });
      section.addEventListener('pointerleave', () => { pointer.on = false; });
      // A tap or click lands like a ball in the net: one strong radial dent.
      section.addEventListener('pointerdown', (e) => {
        if (e.target.closest('input, button, a, label')) return;
        pos(e);
        pts.forEach((p) => {
          if (p.pin) return;
          const dx = p.x - pointer.x, dy = p.y - pointer.y, dist = Math.hypot(dx, dy);
          if (dist < 180 && dist > 0.1) { const f = (1 - dist / 180) * 9; p.vx += (dx / dist) * f; p.vy += (dy / dist) * f; }
        });
        wake();
      });
    });
  }

  /* ---------- Size guide: pick a size, the diagram rescales and the figures roll ---------- */
  function initSizeChart(root = document) {
    $$('[data-size-chart]', root).forEach((sec) => {
      if (sec._sizes) return;
      sec._sizes = true;
      const opts = $$('[data-size-option]', sec);
      if (!opts.length) return;
      const ds = sec.dataset;
      const range = (v, a, b) => (b > a ? (v - a) / (b - a) : 0.5);
      const shirt = $('[data-size-shirt]', sec);
      const giant = $('[data-size-giant]', sec);
      const lenEl = $('[data-size-len]', sec), chestEl = $('[data-size-chest]', sec);
      const lenTag = $('[data-size-len-tag]', sec), chestTag = $('[data-size-chest-tag]', sec);

      const roll = (el, to) => {
        const from = parseFloat(el.textContent) || to;
        if (reduceMotion || from === to) { el.textContent = to; return; }
        const t0 = performance.now(), dur = 520;
        const tick = (t) => {
          const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4);
          el.textContent = Math.round(from + (to - from) * e);
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      const select = (btn, focus) => {
        if (!btn || btn.disabled) return;
        opts.forEach((o) => { const on = o === btn; o.setAttribute('aria-checked', on); o.tabIndex = on ? 0 : -1; });
        if (focus) btn.focus();
        const len = +btn.dataset.len, chest = +btn.dataset.chest, label = btn.dataset.label;
        // Smallest available size draws at 84%, largest at 100%: enough to read the step.
        const sx = 0.84 + 0.16 * range(chest, +ds.minChest, +ds.maxChest);
        const sy = 0.84 + 0.16 * range(len, +ds.minLen, +ds.maxLen);
        if (shirt) { shirt.style.setProperty('--sx', sx.toFixed(3)); shirt.style.setProperty('--sy', sy.toFixed(3)); }
        if (giant && giant.textContent !== label) {
          giant.textContent = label;
          giant.classList.remove('is-swapping'); void giant.offsetWidth; giant.classList.add('is-swapping');
        }
        if (lenEl) roll(lenEl, len);
        if (chestEl) roll(chestEl, chest);
        if (lenTag) lenTag.textContent = len + ' cm';
        if (chestTag) chestTag.textContent = chest + ' cm';
        $$('[data-size-row]', sec).forEach((r) => r.classList.toggle('is-active', r.dataset.sizeRow === label));
      };

      opts.forEach((o) => o.addEventListener('click', () => select(o)));
      $('[data-size-picker]', sec).addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault();
        const live = opts.filter((o) => !o.disabled);
        const i = live.indexOf(document.activeElement);
        const step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
        select(live[(i + step + live.length) % live.length], true);
      });
      $$('[data-size-row]', sec).forEach((r) => r.addEventListener('click', () => {
        select(opts.find((o) => o.dataset.label === r.dataset.sizeRow));
      }));
      select(opts.find((o) => o.getAttribute('aria-checked') === 'true'));
    });
  }

  /* ---------- Boot ---------- */
  function initSection(root) {
    initReveal(root);
    initSwing(root);
    initJersey3D(root);
    initNet(root);
    initSizeChart(root);
    initRails(root);
    initProduct(root);
    initRecommendations(root);
    initFilters(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initMega();
    initMobileMenu();
    initSearch();
    initAnnouncement();
    cart.init();
    initLocalization();
    initAccount();
    initSection(document);
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    initSection(e.target);
    if (e.target.querySelector('[data-header]')) { initMega(); initMobileMenu(); initSearch(); }
  });
})();
